
export enum CountrySelectionMode {
    AllCountries,
    IncludeSpecific,
    ExcludeSpecific
}